<div class="p-6">
  <h2 class="text-2xl font-semibold text-gray-900 mb-6">Edit Paddock</h2>
  
  <form [formGroup]="editPaddockForm" class="space-y-4">
    <div class="space-y-4">
      <!-- Name Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Name</label>
        <input 
          formControlName="name" 
          type="text" 
          placeholder="Enter paddock name"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 placeholder:text-gray-400 placeholder:italic"
        >
      </div>

      <!-- Total Area Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Total Area (ha)</label>
        <input 
          type="number" 
          readonly 
          [value]="paddock.area"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-500 cursor-not-allowed"
        >
      </div>

      <!-- Fences Display (commented out in original) -->
      <!-- <div *ngIf="paddock">
        <label class="block text-sm font-medium text-gray-700 mb-2">Fences</label>
        <div class="flex flex-wrap gap-2">
          <span 
            *ngFor="let fence of paddock.fences" 
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
            [title]="fence.name"
          >
            {{ fence.name }}
          </span>
        </div>
      </div> -->

      <!-- Landuse Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Landuse</label>
        <select 
          formControlName="landuseType"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option [value]="null" disabled>Choose Landuse</option>
          <option *ngFor="let landuseType of landuseTypes" [value]="landuseType">
            {{ landuseType.name }}
          </option>
        </select>
      </div>

      <!-- Enterprise Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Enterprise</label>
        <select 
          formControlName="cropType"
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option [value]="null" disabled>Choose Enterprise</option>
          <option *ngFor="let crop of cropTypes" [value]="crop">
            {{ crop.name }}
          </option>
        </select>
      </div>

      <!-- Notes Field -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Notes</label>
        <textarea 
          formControlName="notes" 
          rows="4"
          placeholder="Enter any additional notes..."
          class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-vertical placeholder:text-gray-400 placeholder:italic"
        ></textarea>
      </div>
    </div>
  </form>

  <!-- Actions -->
  <div class="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-200">
    <button 
      type="button" 
      [mat-dialog-close]="false"
      class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
    >
      Cancel
    </button>
    <button
      type="button"
      (click)="openDeleteConfirmationDialog()"
      class="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
    >
      Delete
    </button>
    <button
      type="button"
      (click)="updatePaddockAndClose()"
      [disabled]="!editPaddockForm.valid"
      class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Update
    </button>
  </div>
</div>
